import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MainTitle, Spinner } from '../../../../common/index.jsx';
import { useGetEventQuery } from '../../../../../redux/services/fo_events.jsx';
import EventsDetail from '../../../../common/FriOpen/Events/EventsDetail.jsx';
import { useGetEventDatesQuery } from '../../../../../redux/services/fo_dates.jsx';

const EventsDetailPublicPage = () => {
  const { t } = useTranslation();
  const { eventId } = useParams();

  const { data: event, isLoading: isLoadingEvent } = useGetEventQuery(eventId);
  const { data: eventDates, isLoading: isLoadingEventDates } =
    useGetEventDatesQuery(eventId);

  return (
    <>
      <MainTitle title={t('FRI akcia')} backAction={true} />

      {isLoadingEvent || isLoadingEventDates ? (
        <Spinner />
      ) : (
        <EventsDetail event={event} eventDates={eventDates} />
      )}
    </>
  );
};

export default EventsDetailPublicPage;
